import React, { useEffect } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import ShadowCard from "../../../components/common/ShadowCard";
import FormDatePicker from "../../../components/formFields/FormDateField";
import moment from "moment";
import { getAllActiveUsers } from "../../user/services/user.services";
import { getAllActiveSectors } from "../../sector/services/sector.services";
import { ISector } from "../../sector/sectorModel";
import { INQUIRYTYPE } from "../../../_contstants/common";
import { IUser } from "../../user/userModel";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const ChangeWatcher: React.FC<ChangeWatcherProps> = ({ formRenderProps }) => {
  useEffect(() => {
    formRenderProps.onChange("filterFromDate", {
      value: moment().startOf("month").toDate(),
    });
    formRenderProps.onChange("filterToDate", {
      value: moment().toDate(),
    });
  }, []);
  return null;
};

const QuotationStatusReportForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);
  const SectorList = useAppSelector((state) => state.sector.SectorList);
  const UserList = useAppSelector((state) => state.user.UserList);

  useEffect(() => {
    dispatch(getAllActiveUsers());
    dispatch(getAllActiveSectors());
  }, []);

  const handleSubmit = (values: any) => {
    const payload: any = {};

    payload.filterFromDate = values?.filterFromDate
      ? moment(values?.filterFromDate).format("YYYY-MM-DD")
      : "0";
    payload.filterToDate = values?.filterToDate
      ? moment(values?.filterToDate).format("YYYY-MM-DD")
      : "0";
    payload.Destination = values?.Destination ? values?.Destination : "0";
    payload.InquiryType = values?.InquiryType ? values?.InquiryType : "0";
    payload.User = values?.User ? values?.User : "0";
    // payload.Status = values?.Status ? values?.Status : "0";
    window.open(
      `quotationstatusreportview/${payload?.filterFromDate}/${payload?.filterToDate}/${payload?.Destination}/${payload?.InquiryType}/${payload?.User}`,
    );
  };

  return (
    <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ cols: 10, rows: 0 }}
                  cols={[{ width: "40%" }, { width: "30%" }, { width: "30%" }]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      Quotation Status Report
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      name="filterFromDate"
                      label="From Date"
                      format="dd/MM/yyyy"
                      wrapperStyle={{ width: "100%" }}
                      component={FormDatePicker}
                      astrike={true}
                      validator={requiredValidator}
                    />
                    <Field
                      name="filterToDate"
                      label="To Date"
                      format="dd/MM/yyyy"
                      minDate={moment(
                        formRenderProps.valueGetter("filterFromDate"),
                      ).toDate()}
                      wrapperStyle={{ width: "100%" }}
                      component={FormDatePicker}
                      astrike={true}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      name="InquiryType"
                      wrapperClassName="w-100"
                      label="Inquiry Type"
                      placeholder="Type"
                      component={FormSelectionField}
                      options={INQUIRYTYPE?.map((type: any) => ({
                        value: type?.value,
                        label: type?.label,
                      }))}
                    />
                    {/* <Field
                      name="Status"
                      wrapperClassName="w-100"
                      label="Status"
                      placeholder="Select Status"
                      component={FormSelectionField}
                      options={QUOTATIONSTATUS?.map((STATUS: any) => ({
                        value: STATUS?.value,
                        label: STATUS?.label,
                      }))}
                    /> */}
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      name="Destination"
                      label="Destination"
                      placeholder="Destination"
                      wrapperClassName="w-50"
                      component={FormSelectionField}
                      options={SectorList?.map((sector: ISector) => ({
                        value: sector?.SectorName,
                        label: sector?.SectorName,
                      }))}
                    />
                    <Field
                      name="User"
                      label="User"
                      placeholder="Select User"
                      wrapperClassName="w-50"
                      component={FormSelectionField}
                      options={UserList?.map((user: IUser) => {
                        return {
                          value: `${user?.FirstName} ${user?.LastName}`,
                          label: `${user?.FirstName} ${user?.LastName}`,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      display: "flex",
                      gap: 10,
                      position: "relative",
                      minHeight: 50,
                    }}
                  >
                    <div style={{ position: "absolute", top: 20, right: 0 }}>
                      <ButtonWithLoading
                        label={"Get Details"}
                        type="submit"
                        Size="medium"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </div>
                  </GridLayoutItem>
                </GridLayout>
                <ChangeWatcher formRenderProps={formRenderProps} />
              </FormElement>
            )}
          />
        </ShadowCard>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default QuotationStatusReportForm;
